'use client'

import { Suspense, useEffect, useState } from 'react'
import { useSearchParams, useRouter } from 'next/navigation'
import Image from 'next/image'

const AmtilLogo = () => (
  <svg className="w-24 h-12" viewBox="0 0 589 299" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M49.1222 0.139856C55.4165 -0.27917 61.6417 0.243396 67.7981 1.70753C74.7459 3.76375 80.631 7.72377 85.4532 13.5876C87.8137 16.8312 90.2425 20.015 92.7396 23.1389C97.5553 28.1992 102.896 32.4385 108.763 35.8569C200.981 69.7866 293.202 103.716 385.42 137.646C448.529 160.779 511.623 183.952 574.7 207.164C578.926 209.095 582.718 211.748 586.075 215.125C589.47 219.338 589.909 223.903 587.395 228.824C585.829 231.368 583.945 233.59 581.744 235.49C574.802 241.152 567.635 246.467 560.245 251.433C534.962 268.18 509.165 284.034 482.852 299C482.726 298.801 482.723 298.599 482.842 298.395C505.12 271.901 527.33 245.349 549.473 218.737C549.412 218.671 549.348 218.604 549.287 218.538C398.626 172.958 247.951 127.442 97.2627 81.9882C94.7125 82.3884 92.2247 83.074 89.7995 84.0453C86.3966 85.9027 83.0772 87.916 79.8412 90.0849C73.1492 93.3189 66.1598 94.5261 58.8728 93.7067C50.6403 92.7036 42.6811 90.4981 34.9951 87.0898C24.6542 82.294 14.8091 76.5581 5.45965 69.8819C4.46508 68.6896 3.47048 67.4972 2.4759 66.3049C4.40704 65.9468 6.35571 65.8431 8.32193 65.9936C16.1946 66.4856 24.0655 67.0109 31.9348 67.5697C37.1209 67.8668 42.2999 67.7698 47.472 67.2788C53.1359 66.2823 57.0728 62.8784 59.2823 57.0672C61.5203 51.0426 61.7863 44.9154 60.0802 38.6858C57.7805 32.6657 53.7288 29.0077 47.9252 27.7119C45.3135 27.2792 42.688 26.9919 40.0488 26.8502C28.271 26.0903 16.495 25.3016 4.72095 24.4843C3.53083 24.3889 2.36876 24.1416 1.2348 23.7423C-0.0357391 23.1077 -0.325793 22.1377 0.364634 20.832C3.02293 17.5857 6.05667 14.8714 9.46589 12.6894C21.8847 5.36438 35.1033 1.18121 49.1222 0.139856Z" fill="rgba(255,255,255,0.15)"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M46.6058 2.81075C50.3834 2.70639 54.1617 2.66927 57.9405 2.69942C68.4407 2.94978 77.1971 7.32697 84.2098 15.831C89.5941 24.016 96.1943 30.7211 104.01 35.9459C105.633 37.0701 107.355 37.9798 109.174 38.6748C212.174 76.5718 315.185 114.471 418.206 152.371C468.651 170.859 519.111 189.291 569.589 207.663C574.209 209.437 578.514 211.845 582.506 214.889C587.273 218.949 587.927 223.68 584.474 229.081C582.123 231.94 579.512 234.446 576.642 236.594C566.767 244.047 556.642 251.099 546.268 257.75C528.789 269.036 511.045 279.797 493.036 290.03C512.625 266.749 532.144 243.41 551.596 220.009C552.077 218.66 551.844 217.487 550.899 216.49C508.348 203.524 465.778 190.597 423.19 177.708C314.704 145.055 206.233 112.372 97.7733 79.6576C91.9099 79.9757 86.6418 82.0926 81.969 86.0084C74.8457 90.446 67.1947 92.2039 59.0162 91.2821C51.2329 90.3103 43.7023 88.2312 36.4246 85.0448C26.4415 80.4704 16.9053 74.9977 7.81624 68.6268C17.0918 69.059 26.3653 69.6253 35.6366 70.326C40.2281 70.4911 44.7946 70.2038 49.336 69.464C52.8725 68.5657 55.8584 66.6598 58.2939 63.746C63.1061 56.2647 64.5568 48.0298 62.6459 39.0414C60.2648 31.6131 55.5887 27.0251 48.617 25.277C46.1814 24.9125 43.7388 24.6218 41.289 24.4051C30.5518 23.7047 19.8138 23.0313 9.0751 22.3845C6.98451 22.224 4.90797 21.9601 2.84544 21.5929C6.29225 17.6357 10.3259 14.5662 14.9463 12.3849C25.048 7.29994 35.6011 4.10853 46.6058 2.81075Z" fill="#2488CF"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M150.84 115.901C151.038 115.676 151.281 115.638 151.57 115.787C271.604 151.147 391.64 186.507 511.675 221.866C512.41 222.121 513.146 222.378 513.881 222.632C514.14 222.702 514.326 222.866 514.438 223.126C510.367 228.567 506.127 233.862 501.714 239.006C501.134 239.316 500.525 239.396 499.89 239.242C397.116 216.596 294.353 193.897 191.599 171.146C177.987 152.736 164.401 134.321 150.84 115.901Z" fill="#E8B419"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M156.944 120.227C156.954 120.118 157.013 120.049 157.124 120.022C274.448 154.653 391.789 189.223 509.145 223.73C509.65 223.826 510.079 224.052 510.436 224.412C507.258 228.571 503.971 232.635 500.578 236.606C500.427 236.643 500.274 236.678 500.123 236.715C398.241 214.26 296.364 191.781 194.495 169.275C193.833 169.098 193.19 168.874 192.564 168.605C180.774 152.39 168.901 136.264 156.944 120.227Z" fill="#82DAF9"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M224.107 191.224C315.16 209.246 406.206 227.321 497.248 245.448C494.232 249.133 491.184 252.791 488.101 256.417C487.206 257.235 486.368 258.124 485.585 259.088C485.248 259.371 484.886 259.611 484.5 259.814C407.832 249.792 331.177 239.655 254.532 229.406C244.323 216.971 234.216 204.445 224.208 191.828C224.118 191.638 224.083 191.437 224.107 191.224Z" fill="#E8B419"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M229.657 195.157C229.698 195.035 229.789 194.967 229.927 194.95C317.58 212.341 405.232 229.706 492.885 247.043C490.036 250.679 486.982 254.066 483.726 257.205C407.727 247.279 331.744 237.232 255.774 227.062C247.085 216.392 238.381 205.757 229.657 195.157Z" fill="#82DAF9"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M287.159 245.547C346.378 251.96 405.601 258.353 464.832 264.724C470.542 265.293 476.222 265.994 481.871 266.827C475.337 274.639 468.51 282.099 461.391 289.21C461.016 289.548 460.594 289.792 460.123 289.94C410.633 285.409 361.157 280.751 311.698 275.967C303.553 266.095 295.409 256.224 287.263 246.352C287.17 246.093 287.134 245.824 287.159 245.547Z" fill="#E8B419"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M292.333 248.881C292.375 248.759 292.465 248.691 292.604 248.674C354.186 255.281 415.762 261.967 477.331 268.728C472.155 274.387 466.944 280.003 461.697 285.571C461.097 286.121 460.495 286.669 459.896 287.219C459.682 287.258 459.471 287.294 459.257 287.332C410.509 282.836 361.766 278.265 313.031 273.621C306.155 265.336 299.255 257.089 292.333 248.881Z" fill="#82DAF9"/>
  </svg>
)

interface UserInfo {
  id: string
  email: string
  full_name: string | null
  avatar_url: string | null
}

interface AuthCheckResponse {
  authenticated: boolean
  user: UserInfo | null
}

function LoginContent() {
  const searchParams = useSearchParams()
  const router = useRouter()
  const [authState, setAuthState] = useState<'loading' | 'authenticated' | 'unauthenticated'>('loading')
  const [user, setUser] = useState<UserInfo | null>(null)
  const [isRedirecting, setIsRedirecting] = useState(false)

  const redirectPath = searchParams.get('redirect') || '/'

  useEffect(() => {
    async function checkAuth() {
      try {
        const response = await fetch('/api/auth/check')
        const data: AuthCheckResponse = await response.json()

        if (data.authenticated && data.user) {
          setUser(data.user)
          setAuthState('authenticated')
        } else {
          setAuthState('unauthenticated')
        }
      } catch {
        setAuthState('unauthenticated')
      }
    }

    checkAuth()
  }, [])

  const handleContinue = () => {
    setIsRedirecting(true)
    router.push(redirectPath)
  }

  const handleSignIn = () => {
    setIsRedirecting(true)
    // Redirect to Encyclopedia's OAuth with Connect as the callback destination
    const encyclopediaUrl = process.env.NEXT_PUBLIC_ENCYCLOPEDIA_URL || 'https://app.amtil.co'
    const appUrl = process.env.NEXT_PUBLIC_APP_URL || 'https://connect.amtil.co'
    const oauthUrl = new URL(`${encyclopediaUrl}/api/auth/google`)
    // After OAuth completes, redirect back to Connect
    const connectCallback = `${appUrl}${redirectPath}`
    oauthUrl.searchParams.set('redirect', connectCallback)
    window.location.href = oauthUrl.toString()
  }

  const handleDifferentAccount = () => {
    setIsRedirecting(true)
    // Sign in with a different account - go through OAuth flow
    const encyclopediaUrl = process.env.NEXT_PUBLIC_ENCYCLOPEDIA_URL || 'https://app.amtil.co'
    const appUrl = process.env.NEXT_PUBLIC_APP_URL || 'https://connect.amtil.co'
    const oauthUrl = new URL(`${encyclopediaUrl}/api/auth/google`)
    const connectCallback = `${appUrl}${redirectPath}`
    oauthUrl.searchParams.set('redirect', connectCallback)
    oauthUrl.searchParams.set('prompt', 'select_account') // Force account selection
    window.location.href = oauthUrl.toString()
  }

  // Loading state
  if (authState === 'loading') {
    return (
      <div className="animate-pulse flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-primary-400 border-t-transparent rounded-full animate-spin" />
        <p className="text-white/60 text-sm font-medium">Checking session...</p>
      </div>
    )
  }

  return (
    <div className="w-full max-w-md">
      {/* Card */}
      <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl">
        {/* AMTIL Logo */}
        <div className="flex justify-center mb-6">
          <AmtilLogo />
        </div>

        {/* Live Indicator */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-status-live opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-status-live" />
          </span>
          <span className="text-white/60 text-xs font-semibold uppercase tracking-wider">
            Broadcast Ready
          </span>
        </div>

        {authState === 'authenticated' && user ? (
          /* Authenticated State - Continue as User */
          <>
            <h2 className="text-white text-2xl font-bold text-center mb-2">
              Welcome back
            </h2>
            <p className="text-white/50 text-sm text-center mb-8">
              Continue to your session
            </p>

            {/* User Profile Card */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-4 mb-6">
              <div className="flex items-center gap-4">
                {user.avatar_url ? (
                  <Image
                    src={user.avatar_url}
                    alt={user.full_name || 'User'}
                    width={48}
                    height={48}
                    className="rounded-full ring-2 ring-primary-400/50"
                  />
                ) : (
                  <div className="w-12 h-12 bg-primary-500/30 rounded-full flex items-center justify-center ring-2 ring-primary-400/50">
                    <span className="text-primary-200 font-bold text-lg">
                      {(user.full_name || user.email || '?')[0].toUpperCase()}
                    </span>
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-white font-semibold truncate">
                    {user.full_name || 'AMTIL User'}
                  </p>
                  <p className="text-white/40 text-sm truncate">
                    {user.email}
                  </p>
                </div>
              </div>
            </div>

            {/* Continue Button */}
            <button
              onClick={handleContinue}
              disabled={isRedirecting}
              className="w-full py-3 px-4 bg-primary-500 hover:bg-primary-400 disabled:bg-primary-500/50 text-white font-bold rounded-xl transition-all duration-200 shadow-lg shadow-primary-500/25 hover:shadow-primary-400/40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isRedirecting ? (
                <>
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  <span>Entering session...</span>
                </>
              ) : (
                <>
                  <span>Continue as {user.full_name?.split(' ')[0] || 'User'}</span>
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </>
              )}
            </button>

            {/* Use Different Account Link */}
            <button
              onClick={handleDifferentAccount}
              disabled={isRedirecting}
              className="w-full mt-3 py-2 text-white/50 hover:text-white/70 text-sm font-medium transition-colors disabled:opacity-50"
            >
              Use a different account
            </button>
          </>
        ) : (
          /* Unauthenticated State - Sign In */
          <>
            <h2 className="text-white text-2xl font-bold text-center mb-2">
              Join the session
            </h2>
            <p className="text-white/50 text-sm text-center mb-8">
              Sign in to access AMTIL Connect
            </p>

            {/* Google Sign In Button */}
            <button
              onClick={handleSignIn}
              disabled={isRedirecting}
              className="w-full py-3 px-4 bg-white hover:bg-gray-50 disabled:bg-white/80 text-gray-800 font-semibold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl disabled:cursor-not-allowed flex items-center justify-center gap-3"
            >
              {isRedirecting ? (
                <>
                  <div className="w-5 h-5 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
                  <span>Redirecting...</span>
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                  </svg>
                  <span>Sign in with Google</span>
                </>
              )}
            </button>

            {/* Info Text */}
            <p className="mt-6 text-white/30 text-xs text-center">
              By signing in, you agree to AMTIL&apos;s Terms of Service and Privacy Policy
            </p>
          </>
        )}
      </div>

      {/* Footer Info */}
      <div className="mt-8 text-center">
        <p className="text-white/30 text-xs">
          Part of the AMTIL Aviation Training Platform
        </p>
      </div>
    </div>
  )
}

function LoadingFallback() {
  return (
    <div className="animate-pulse flex flex-col items-center gap-4">
      <div className="w-12 h-12 border-4 border-primary-400 border-t-transparent rounded-full animate-spin" />
      <p className="text-white/60 text-sm font-medium">Loading...</p>
    </div>
  )
}

export default function ConnectLoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-900 via-primary-900 to-navy-800 flex flex-col">
      {/* Header */}
      <header className="p-6 relative z-10">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary-500/20 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6 text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
              <path d="M13 7 9 3 5 7l4 4" />
              <path d="m17 11 4 4-4 4-4-4" />
              <path d="m8 12 4 4 6-6-4-4Z" />
              <path d="m16 8 3-3" />
              <path d="M9 21a6 6 0 0 0-6-6" />
            </svg>
          </div>
          <div>
            <h1 className="text-white font-bold text-lg tracking-tight">AMTIL Connect</h1>
            <p className="text-white/40 text-xs font-medium">Live Sessions</p>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-6 relative z-10">
        <Suspense fallback={<LoadingFallback />}>
          <LoginContent />
        </Suspense>
      </main>

      {/* Background Elements */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        {/* Grid Pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(6,111,169,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(6,111,169,0.03)_1px,transparent_1px)] bg-[size:75px_75px]" />
        {/* Radial Glow */}
        <div className="absolute top-1/4 -left-1/4 w-1/2 h-1/2 bg-primary-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-accent-500/5 rounded-full blur-3xl" />

        {/* Globe wireframe illustration (bottom-left) */}
        <svg
          className="absolute bottom-[-10%] left-[-8%] w-[70%] max-w-[700px]"
          style={{ opacity: 0.07 }}
          viewBox="0 0 600 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="300" cy="300" r="220" stroke="#2488CF" strokeWidth="1.2" />
          <ellipse cx="300" cy="300" rx="220" ry="70" stroke="#2488CF" strokeWidth="0.8" />
          <ellipse cx="300" cy="300" rx="220" ry="140" stroke="#2488CF" strokeWidth="0.8" />
          <ellipse cx="300" cy="220" rx="190" ry="30" stroke="#2488CF" strokeWidth="0.6" />
          <ellipse cx="300" cy="380" rx="190" ry="30" stroke="#2488CF" strokeWidth="0.6" />
          <ellipse cx="300" cy="300" rx="70" ry="220" stroke="#2488CF" strokeWidth="0.8" />
          <ellipse cx="300" cy="300" rx="140" ry="220" stroke="#2488CF" strokeWidth="0.8" />
          <line x1="80" y1="300" x2="520" y2="300" stroke="#2488CF" strokeWidth="0.6" />
          <line x1="300" y1="80" x2="300" y2="520" stroke="#2488CF" strokeWidth="0.6" />
        </svg>

        {/* Satellite + orbit paths (top-right) */}
        <svg
          className="absolute top-[-15%] right-[0%] w-[55%] max-w-[550px]"
          style={{ opacity: 0.14 }}
          viewBox="0 0 500 500"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Orbit ellipses */}
          <ellipse cx="250" cy="280" rx="230" ry="120" stroke="#2488CF" strokeWidth="0.8" strokeDasharray="6 4" transform="rotate(-20 250 280)" />
          <ellipse cx="250" cy="280" rx="190" ry="95" stroke="#2488CF" strokeWidth="0.6" strokeDasharray="4 6" transform="rotate(-20 250 280)" />
          <ellipse cx="250" cy="280" rx="150" ry="70" stroke="#2488CF" strokeWidth="0.5" strokeDasharray="3 5" transform="rotate(-20 250 280)" />

          {/* Satellite body */}
          <g transform="translate(410, 178) rotate(25)" stroke="#2488CF">
            <rect x="-8" y="-6" width="16" height="12" rx="2" strokeWidth="1.2" />
            <rect x="-32" y="-10" width="22" height="20" rx="1" strokeWidth="0.8" />
            <line x1="-28" y1="-10" x2="-28" y2="10" strokeWidth="0.5" />
            <line x1="-22" y1="-10" x2="-22" y2="10" strokeWidth="0.5" />
            <line x1="-16" y1="-10" x2="-16" y2="10" strokeWidth="0.5" />
            <rect x="10" y="-10" width="22" height="20" rx="1" strokeWidth="0.8" />
            <line x1="16" y1="-10" x2="16" y2="10" strokeWidth="0.5" />
            <line x1="22" y1="-10" x2="22" y2="10" strokeWidth="0.5" />
            <line x1="28" y1="-10" x2="28" y2="10" strokeWidth="0.5" />
            <line x1="0" y1="-6" x2="0" y2="-16" strokeWidth="0.8" />
            <circle cx="0" cy="-18" r="2" strokeWidth="0.8" fill="none" />
          </g>

          {/* Signal waves */}
          <g stroke="#2488CF" fill="none" transform="translate(410, 178)">
            <path d="M-12 22 Q-28 38 -20 56" strokeWidth="0.6" />
            <path d="M-8 24 Q-22 42 -14 62" strokeWidth="0.5" />
            <path d="M-4 26 Q-16 46 -8 68" strokeWidth="0.4" />
          </g>

          {/* Orbit dots */}
          <circle cx="70" cy="210" r="2" fill="#2488CF" />
          <circle cx="148" cy="360" r="1.5" fill="#2488CF" />
          <circle cx="380" cy="370" r="1.5" fill="#2488CF" />
        </svg>
      </div>
    </div>
  )
}
